import React from 'react';

import { Banner } from '@modules';
import { InitialStatePropType } from '@propTypes';
import { TopbannerProvider } from '@contexts';

const Container = ({ state: initialState }) => (
  <TopbannerProvider initialState={initialState}>
    <Banner />
  </TopbannerProvider>
);

Container.propTypes = {
  state: InitialStatePropType.isRequired,
};

export default Container;
